import { render, staticRenderFns } from "./ManagementVerdeSysNotifications.vue?vue&type=template&id=080e4fe8&"
import script from "./ManagementVerdeSysNotifications.vue?vue&type=script&lang=js&"
export * from "./ManagementVerdeSysNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports